const haveRijectVisaScores = [
    { min: 0, max: 27, isRiject: true, score: -20 },
    { min: 27, max: 40, isRiject: true, score: -20 },
    { min: 40, max: 55, isRiject: true, score: -20 },
    { min: 55, max: 200, isRiject: true, score: -20 }
];

export default haveRijectVisaScores;
